import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(ScrollTrigger, SplitText);

let split, animation;

export function setupSplit() {
	const splitText = document.querySelector('.split-text');
	if (!splitText) return;

	// 🔄 Nettoyage avant de recréer
	if (split) split.revert();
	if (animation) animation.kill();
	// ScrollTrigger.getAll().forEach((trigger) => trigger.kill()); // supprime les anciens triggers

	// ✂️ Split du texte
	split = SplitText.create('.split-text', {
		type: 'lines',
		mask: 'lines',
		linesClass: 'hero__title-line',
	});

	// 🎬 Animation avec ScrollTrigger
	animation = gsap.from(split.lines, {
		opacity: 0,
		rotationX: -60,
		transformOrigin: '50% 50% -160px',
		ease: 'power3.out',
		duration: 1,
		delay: 0,
		stagger: 0.2,
		scrollTrigger: {
			trigger: '.split-text', // déclencheur
			start: 'top 85%', // quand le haut de l'élément atteint 85% du viewport
			toggleActions: 'play none none reverse',
			// once: true,
			// invalidateOnRefresh: true
		},
	});
}

// ✅ Recalculer au resize (utile si responsive)
window.addEventListener('resize', setupSplit);

// window.addEventListener('load', () => {
// 	setTimeout(setupSplit, 750);
// });